module.exports = __webpack_public_path__ + "banner_text.229217e3.png";